import {
    selectDoc,
    event,
    selectArr,
    toggleClass,
    removeClassAll, addClass
} from "../utils/utils";

import {initSlider} from "../helpers/service.slider";

const props = {
    html: selectDoc('html'),
    reviewsTabsContainer: selectDoc('#testimonials-section .tabs'),
    reviewsTabs: selectArr('#testimonials-section .tabs button'),
    clientReviews: selectArr('#testimonials-section .read-more .opinion p'),
    modalContainer: selectDoc('#testimonials-section .modal-container'),
    modalsClose: selectArr('#testimonials-section .modal-container button.btn--close'),
    reviewsSliders: selectArr('#testimonials-section .magazines-slider'),
}

const initSliderTabs = () => {

    let leftTabs = [];
    props.reviewsTabs.map(tab => {
        event(tab, 'click', function () {
            removeClassAll(props.reviewsTabs, 'active')
            addClass(tab, 'active')

            removeClassAll(props.reviewsSliders,  'active')
            let slider = selectDoc(`#${tab.getAttribute('data-target')}`)
            if(slider) {
                addClass(slider, 'active')
            }
        });

        let slides = selectArr(`#${tab.getAttribute('data-target')} .glide__slide`);
        if(slides.length < 1) {
            let removeSlider = selectDoc(`#${tab.getAttribute('data-target')}`);
            removeSlider.parentNode.removeChild(removeSlider);
        } else {
            leftTabs.push(tab);
        }
    });

    if(leftTabs.length > 0) {
        leftTabs[0].click();
    }
    if(leftTabs.length < 2) {
        props.reviewsTabsContainer.style.opacity = '0';
    }

    selectArr('.magazines-slider').map(magazineSlider => {
        initSlider(`#${magazineSlider.id}`, {
            perView: 3,
            type: 'carousel',
            rewind: true,
            bound: true,
            hoverpause: false,
            animationDuration: 1000,
            gap: 30,
            peek: {
                before: 0,
                after: 0
            },
            breakpoints: {
                1024: {
                    perView:2
                },
                767: {
                    animationDuration: 500,
                    perView: 1,
                    gap: 10,
                    peek: {
                        before: 0,
                        after: 70
                    }
                }
            }
        }, true);
    })

    addClass(selectDoc('.magazines-slider'), 'active')

    props.clientReviews.map(review => {
        let readMore = document.createElement('button')
        readMore.classList.add('btn--arrow')
        readMore.innerHTML = 'Read More'
        event(readMore, 'click', function () {
            let modal = selectDoc(`#${review.parentNode.getAttribute('data-target')}`)
            if(modal) {
                modal.classList.add('active')
                toggleClass(props.modalContainer, 'active')
            }
        })

        review.innerHTML = review.innerHTML.slice(0, 320) + '... ';
        review.appendChild(readMore)
    })

    props.modalsClose.map(close => {
        event(close, 'click', function () {
            close.parentNode.classList.remove('active')
            toggleClass(props.modalContainer, 'active')
        })
    })
}

const initializer = () => {
    initSliderTabs();
}

export const Testimonials = {
    init: () => initializer()
}
